import React from 'react'
import BaseCSS from '../css/base'
import PrismCSS from '../css/prism'

function CSS() {
  return (
    <>
      <BaseCSS />
      <PrismCSS />
    </>
  )
}

export default CSS
